import { storage } from '@/repository/client/storage'
import { LessonSsRepository } from '@/repository/LessonSsRepository'

class SsSaver {
  constructor() {
    this.repo = new LessonSsRepository(storage)
  }

  async execute(id, file) {
    return await this.repo.put(file, this._createPath(id))
  }

  _createTimeStamp() {
    return new Date().toString()
  }

  _createPath(id) {
    return `${id}/${this._createTimeStamp()}.jpg`
  }
}

export { SsSaver }